import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import './SpeedDial.css';

/**
 * Bottom-right FAB: add a character. Used to also fan out to a full-roster
 * resync, but that moved to the top-left sync button (global, open to
 * everyone) — with only one action left, the fan-out submenu wasn't worth
 * keeping either.
 */
export function SpeedDial({ onAddCharacter }: { onAddCharacter: () => void }) {
  const { t } = useTranslation();

  return (
    <div className="speed-dial">
      <button
        type="button"
        className="speed-dial-main btn btn-primary"
        onClick={onAddCharacter}
        aria-label={t('roster.addCharacter')}
      >
        <Plus size={22} />
      </button>
    </div>
  );
}
